import { render, staticRenderFns } from "./EditCharacteristics.vue?vue&type=template&id=b1ce974c&scoped=true"
import script from "./EditCharacteristics.vue?vue&type=script&lang=js"
export * from "./EditCharacteristics.vue?vue&type=script&lang=js"
import style0 from "./EditCharacteristics.vue?vue&type=style&index=0&id=b1ce974c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ce974c",
  null
  
)

export default component.exports